import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { FaReceipt } from 'react-icons/fa';
import { FaBell } from 'react-icons/fa6';

import { IoVolumeHigh } from 'react-icons/io5';
import { BsChatFill } from 'react-icons/bs';

import {
  DropdownMenu,
  UncontrolledDropdown,
  DropdownToggle,
  Dropdown
} from 'reactstrap';
import ProtocolModal from './ProtocolModal';
import NotificationForm from './NotificationForm';
import io from 'socket.io-client';
import { TelephonyServicePanel } from './TelephonyServicePanel';

import { useSocketCallAnswered } from './ProtocolModal/hooks/useSocketCallAnswered';
import PauseServicePanel from './LoginQueueChat';
import { verifyRoles } from '../../../components/Authentication/VerifyRoles';
import { useQueueChatPauseContext } from '../../../hooks/useQueuePauseChatServicePanel';
import ModalPauseConfirmation from './TelephonyServicePanel/components/ModalPauseConfirmation';
import ding from '../../../assets/audios/ding.mp3';
import ModalClosePauseConfirmation from './TelephonyServicePanel/components/ModalClosePauseConfirmation';

import GeneralNotificationService from './NotificationForm/service/GeneralNotificationService.js';

import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import ModalSchedulingProtocol from 'views/Protocol/form/components/ModalSchedulingProtocol';
import ModalScheduling from '../../../views/CRM/Scheduling/ModalScheduling';
import ModalSoftphone from './softphone';
import { SessionState } from 'sip.js';
import userAgentSingleton from './softphone/userAgent/userAgentSingleton';
import { PlayNewAlert } from 'components/Notifications/components/Alerts';
import { FiHelpCircle } from 'react-icons/fi';
import UptimeCounter from './UptimeCounter';
import FlexNotificationFormAlert from './FlexNotificationFormAlert';

const speakerStyle = { cursor: 'pointer', color: 'white', marginTop: '3px' };

//Barra do Menu Superior
const ServicePanel = () => {
  const history = useHistory();
  const {
    inQueueChatPause,
    getInitialValuesQueueChatPause,
    queuesChatLoggedValues,
    dateOfStartChatPause,
    currentQueueChatPause
  } = useQueueChatPauseContext();

  const iconChatWithoutBorder =
    !inQueueChatPause && queuesChatLoggedValues.length === 0;

  const socketNotification = useMemo(
    () =>
      io(process.env.REACT_APP_PROXY_URL, {
        path: process.env.REACT_APP_NOTIFICATION_PATH_SOCKET
      }),
    []
  );

  const socketScales = useMemo(
    () =>
      io(process.env.REACT_APP_PROXY_URL, {
        path: process.env.REACT_APP_SCALE_PATH_SOCKET
      }),
    []
  );

  const { answeringCall, resetAnsweringCall } = useSocketCallAnswered();
  const [isProtocolModalOpen, setIsProtocolModalOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [finishedPause, setFinishedPause] = useState(false);
  const [notificationQuantity, setNotificationsQuantity] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownNotificationOpen, setIsDropdownNotificationOpen] =
    useState(false);
  const [isSchedulingModalOpen, setIsSchedulingModalOpen] = useState(false);
  const [isSchedulingCrmModalOpen, setIsSchedulingCrmModalOpen] =
    useState(false);
  const [schedulingId, setSchedulingId] = useState();

  const [callState, setCallState] = useState(undefined);
  const [callStateStatus, setCallStateStatus] = useState(undefined);
  const [callStateColor, setCallStateColor] = useState(undefined);

  useEffect(() => {
    const audio = JSON.parse(localStorage.getItem('@flexuc/audioEnabled'));

    if (audio === false) {
      localStorage.setItem('@flexuc/audioEnabled', 'false');
    }

    if (audio === null) {
      localStorage.setItem('@flexuc/audioEnabled', 'true');
    }
  }, []);

  const alertConfirmation = useCallback((eventData) => {
    const agentLocal = localStorage.getItem('agent_code');
    const agentSocket = eventData.agentCode;
    if (agentSocket === agentLocal) {
      playSound();
      setIsOpen(true);
    }
  }, []);

  const finishedConfirmation = useCallback((eventData) => {
    const agentLocal = localStorage.getItem('agent_code');
    const agentSocket = eventData.agentCode;
    if (agentSocket === agentLocal) {
      playSound();
      setFinishedPause(true);
    }
  }, []);

  useEffect(() => {
    socketScales.on('connect', () => {
      socketScales.emit('overtime_room:create', localStorage.getItem('login'));
    });
  }, [socketScales]);

  useEffect(() => {
    socketScales.on('automatic_logout', () => {
      toast.info(`Logout automatico ocorrerá em breve!`, {
        autoClose: 3000
      });
      setTimeout(() => {
        history.push('/user/logout');
      }, 3000);
    });
  }, [socketScales, history]);

  useEffect(() => {
    socketScales.on('automatic_pause_confirmation', (eventData) => {
      alertConfirmation(eventData);
    });
  }, [socketScales, alertConfirmation]);

  useEffect(() => {
    socketScales.on('automatic_pause_finished_alert', (eventData) => {
      finishedConfirmation(eventData);
    });
  }, [socketScales, finishedConfirmation]);

  // Notificações gerais
  useEffect(() => {
    socketNotification.on('connect', () => {
      socketNotification.emit(
        'notification_room:create',
        localStorage.getItem('login')
      );
    });
  }, [socketNotification]);

  useEffect(() => {
    const userLogin = localStorage.getItem('login');
    socketNotification.on('flex_notification_event', (data) => {
      if (
        (data?.type === 'scheduling_crm' ||
          data?.type === 'scheduling_protocol') &&
        data?.to === userLogin &&
        (data?.content.includes(
          'Você tem um agendamento de um protocolo para agora.'
        ) ||
          data?.content.includes(
            `Você tem um agendamento de um ${
              data?.entity === 'LEAD' ? 'Lead' : 'Oportunidade'
            } para agora.`
          ) ||
          data?.content.includes(
            'Você tem uma ligação marcada agora para o número'
          ))
      ) {
        let permission = window.Notification.permission;
        PlayNewAlert(data, permission, '', null, true);
      }
      loadApiNotificationsQuantity();
    });
  }, [socketNotification]);

  useEffect(() => {
    try {
      getInitialValuesQueueChatPause();
    } catch (err) {
      console.error(err);
    }
  }, [getInitialValuesQueueChatPause]);

  const isObjectFilled = (obj) => {
    return Object.keys(obj).length ? true : false;
  };

  useEffect(() => {
    if (isObjectFilled(answeringCall)) {
      setIsProtocolModalOpen(true);
      if (answeringCall?.externalScreen) {
        window.open(answeringCall.externalScreen, '_blank');
      }
    }
  }, [answeringCall, resetAnsweringCall]);

  useEffect(() => {
    if (!isProtocolModalOpen) resetAnsweringCall();
  }, [isProtocolModalOpen, resetAnsweringCall]);

  const loadApiNotificationsQuantity = async () => {
    let notifications = [];
    await GeneralNotificationService.getNotificationUNREAD().then((res) => {
      const response = res.data.data;

      response.map((item) => {
        if (item.isNew) {
          notifications.push(item);
        }
      });
    });

    setNotificationsQuantity(notifications);
  };

  const cleanGeneralNotifications = async () => {
    let generalNotificationsIds = [];

    notificationQuantity.map((item) => {
      if (item.isNew) {
        generalNotificationsIds.push(item.id);
      }
    });

    if (generalNotificationsIds.length > 0) {
      await GeneralNotificationService.markNotificationAsSeen(
        generalNotificationsIds
      )
        .then(() => {
          loadApiNotificationsQuantity();
        })
        .catch((err) => toast.error(err));
    }
  };

  useEffect(() => {
    loadApiNotificationsQuantity();
  }, []);

  const playSound = () => {
    const audio = new Audio(ding);
    audio.crossOrigin = 'anonymous';
    audio.play();
  };

  const toggleDropdown = () => setIsDropdownOpen((prevState) => !prevState);

  const toggleNotificationDropdown = () => {
    setIsDropdownNotificationOpen((prevState) => !prevState);
  };

  const changeRangeAudioNotificationVolume = (e) => {
    localStorage.setItem(
      '@flexuc/audioNotificationVolume',
      String(e.target.value)
    );
  };

  const updateCallState = (state) => {
    const isInvitation =
      userAgentSingleton.session?.sessionType === 'Invitation';
    switch (state) {
      case SessionState.Initial:
        setCallStateStatus('Disponível');
        setCallStateColor('#00a118');
        setCallState(state);
        break;
      case SessionState.Establishing:
        setCallStateStatus(isInvitation ? 'Estabilizando' : 'Chamando');
        setCallStateColor('blue');
        setCallState(state);
        break;
      case SessionState.Established:
        setCallStateStatus('Em ligação');
        setCallStateColor('red');
        setCallState(state);
        break;
      case SessionState.Terminating:
        setCallStateStatus('Encerrando ligação');
        setCallStateColor('red');
        setCallState(state);
        break;
      case SessionState.Terminated:
        setCallStateStatus('Disponível');
        setCallStateColor('#00a118');
        setCallState(SessionState.Initial);
        break;
      case undefined:
        setCallStateStatus(undefined);
        setCallStateColor(undefined);
        setCallState(undefined);
        break;
    }
  };

  const getColorButtonChatQueue = () => {
    if (inQueueChatPause && currentQueueChatPause) {
      if (currentQueueChatPause?.active) return '#f97316';
      return '#2365e0';
    }
    if (!inQueueChatPause && queuesChatLoggedValues.length === 0) return '#fff';
    return '#34d399';
  };

  const makeTileChatButton = () => {
    if (inQueueChatPause && currentQueueChatPause) {
      if (currentQueueChatPause?.active) return 'Em pausa ativa';
      return 'Em pausa';
    } else {
      if (queuesChatLoggedValues?.length === 0) return 'Logar em filas do chat';
      else return 'Em atendimento';
    }
  };

  return (
    <>
      {verifyRoles(['VIEW_MANUAL']) ? (
        <div
          onClick={() => {
            if (window.location.host.includes('localhost')) {
              window.open(
                `${process.env.REACT_APP_PROXY_URL}manual/docs/introducao/`,
                '_blank'
              );
            } else {
              window.open(
                `${window.location.origin}/manual/docs/introducao/`,
                '_blank'
              );
            }
          }}
          style={{ marginRight: '2rem', marginLeft: '2rem' }}
        >
          <FiHelpCircle size={24} style={speakerStyle} />
        </div>
      ) : null}

      {verifyRoles(['ATTENDANCE_PANEL']) ? (
        <Dropdown
          nav
          isOpen={isDropdownNotificationOpen}
          toggle={toggleNotificationDropdown}
        >
          <DropdownToggle
            className="nav-link"
            color=""
            tag="a"
            style={{
              cursor: 'pointer'
            }}
            title="Notificações"
          >
            <IoVolumeHigh size={26} style={speakerStyle} />
          </DropdownToggle>
          <DropdownMenu
            className="dropdown-menu-sm py-0 overflow-y-visible p-10"
            right
          >
            {isDropdownNotificationOpen ? (
              <FlexNotificationFormAlert
                isOpen={isDropdownNotificationOpen}
                changeRangeAudioNotificationVolume={
                  changeRangeAudioNotificationVolume
                }
              />
            ) : (
              <></>
            )}
          </DropdownMenu>
        </Dropdown>
      ) : (
        <></>
      )}

      <Dropdown nav isOpen={isDropdownOpen} toggle={toggleDropdown}>
        <DropdownToggle
          className="nav-link"
          color=""
          tag="a"
          style={{
            cursor: 'pointer'
          }}
          title="Notificações"
        >
          {notificationQuantity.length > 0 ? (
            <>
              <div
                style={{
                  position: 'absolute',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  bottom: '20px',
                  left: '30px',
                  width: '1.1rem',
                  height: '1.1rem',
                  background: 'white',
                  color: 'black',
                  fontWeight: '600',
                  fontSize: '0.8rem',
                  borderRadius: '100%',
                  textAlign: 'center'
                }}
              >
                <span>
                  {notificationQuantity.length > 9
                    ? '9+'
                    : notificationQuantity.length}
                </span>
              </div>
              <i>
                <FaBell
                  size={22}
                  onClick={() => {
                    cleanGeneralNotifications();
                  }}
                  style={{ position: 'relative' }}
                />
              </i>
            </>
          ) : (
            <i>
              <FaBell size={22} />
            </i>
          )}
        </DropdownToggle>
        <DropdownMenu
          className="dropdown-menu-xl py-0 overflow-y-visible"
          right
        >
          <NotificationForm
            isOpen={isDropdownOpen}
            setSchedulingId={setSchedulingId}
            setIsSchedulingModalOpen={setIsSchedulingModalOpen}
            setIsSchedulingCrmModalOpen={setIsSchedulingCrmModalOpen}
          />
        </DropdownMenu>
      </Dropdown>

      {verifyRoles(['PAUSE_CHAT_SERVICE_PAINEL']) && (
        <UncontrolledDropdown nav>
          <DropdownToggle
            className="nav-link"
            tag="a"
            style={{ cursor: 'pointer' }}
            title={makeTileChatButton()}
          >
            <BsChatFill
              strokeWidth={iconChatWithoutBorder ? 0 : 1}
              stroke="#fff"
              size={24}
              style={{
                marginLeft: '2px',
                marginRight: '2px',
                color: getColorButtonChatQueue()
              }}
            />

            {inQueueChatPause && (
              <UptimeCounter startDate={dateOfStartChatPause} />
            )}
          </DropdownToggle>
          <DropdownMenu
            className="dropdown-menu-xl py-0 overflow-y-visible"
            right
          >
            <PauseServicePanel />
          </DropdownMenu>
        </UncontrolledDropdown>
      )}

      {verifyRoles(['CREATE_PROTOCOL']) && (
        <>
          <UncontrolledDropdown nav>
            <DropdownToggle
              className="nav-link"
              color=""
              tag="a"
              style={{ cursor: 'pointer' }}
              onClick={() => setIsProtocolModalOpen(true)}
            >
              <FaReceipt size={24} />
            </DropdownToggle>
          </UncontrolledDropdown>
          <ProtocolModal
            isModalOpen={isProtocolModalOpen}
            onModalToggle={setIsProtocolModalOpen}
            unmountOnClose={true}
            defaultFormData={
              isObjectFilled(answeringCall) ? answeringCall : null
            }
          />
        </>
      )}

      {verifyRoles(['TELEPHONY_SERVICE_PANEL']) && <TelephonyServicePanel />}
      <ModalPauseConfirmation isModalOpen={isOpen} onModalToggle={setIsOpen} />
      <ModalClosePauseConfirmation
        isModalOpen={finishedPause}
        onModalToggle={setFinishedPause}
      />
      <ModalSchedulingProtocol
        className="modal-lg"
        show={isSchedulingModalOpen}
        onModalToggle={setIsSchedulingModalOpen}
        schedulingId={schedulingId}
        setschedulingId={setSchedulingId}
        isToCreateScheduling={false}
        isToUpdateScheduling={true}
        isFromNotification={true}
      />
      <ModalScheduling
        className="modal-lg"
        show={isSchedulingCrmModalOpen}
        onModalToggle={setIsSchedulingCrmModalOpen}
        schedulingId={schedulingId}
        setschedulingId={setSchedulingId}
        isToCreateScheduling={false}
        isToUpdateScheduling={true}
        isFromNotification={true}
      />
      <ModalSoftphone
        updateCallState={updateCallState}
        callState={callState}
        callStateStatus={callStateStatus}
        callStateColor={callStateColor}
      ></ModalSoftphone>
    </>
  );
};

export default ServicePanel;
